/* TypeTopia: soft snow behind a page (v1, 2026-10-22)
   assets/tt-snow.js. Ally: the Christmas pages on #f76b6b "can we make it snow maybe? subtle though". Loaded by a
   section that wants it (the Christmas page: sections/tt-extras.liquid with "Snow" on), it starts by itself: white
   flakes of a few sizes drifting down a fixed layer behind the page (the section above it sits at z-index 1), a few
   for a phone and never more than 90, drawn only while the tab is showing; reduced motion gets them standing still.
   The gift tags page's own copy is in assets/tt-tags-present.js (snow()). */
(function () {
  if (window.TTSnow) return;
  var RM = matchMedia("(prefers-reduced-motion: reduce)").matches, on = false;
  function start() {
    if (on || !document.body) return; on = true;
    var c = document.createElement("canvas"); c.className = "tt-snow"; c.setAttribute("aria-hidden", "true");
    c.style.cssText = "position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:0";
    document.body.insertBefore(c, document.body.firstChild);
    var x = c.getContext("2d"), W = 0, H = 0, d = 1, F = [], raf = 0, last = 0;
    function flake(any) {
      var r = .8 + Math.random() * 1.9;
      return { x: Math.random() * W, y: any ? Math.random() * H : -6, r: r, v: 10 + r * 9 + Math.random() * 6, p: Math.random() * 7, a: .35 + Math.random() * .45 };
    }
    function size() {
      W = innerWidth; H = innerHeight; d = Math.min(devicePixelRatio || 1, 1.5);
      c.width = Math.round(W * d); c.height = Math.round(H * d);
      var n = Math.max(24, Math.min(90, Math.round(W * H / 15000)));
      while (F.length < n) F.push(flake(true));
      F.length = n;
    }
    function paint() {
      x.setTransform(d, 0, 0, d, 0, 0); x.clearRect(0, 0, W, H); x.fillStyle = "#fff";
      F.forEach(function (f) { x.globalAlpha = f.a; x.beginPath(); x.arc(f.x + Math.sin(f.p) * 6, f.y, f.r, 0, 7); x.fill(); });
      x.globalAlpha = 1;
    }
    function step(now) {
      raf = 0; if (document.hidden) return;
      var dt = Math.min(.05, (now - last) / 1000); last = now;
      F.forEach(function (f, i) { f.y += f.v * dt; f.p += dt * .8; if (f.y > H + 6) F[i] = flake(false); });
      paint(); raf = requestAnimationFrame(step);
    }
    function go() { if (!raf && !document.hidden) { last = performance.now(); raf = requestAnimationFrame(step); } }
    size(); addEventListener("resize", function () { size(); if (RM) paint(); });
    if (RM) paint(); else { go(); document.addEventListener("visibilitychange", go); }
  }
  window.TTSnow = { start: start };
  if (document.body) start(); else document.addEventListener("DOMContentLoaded", start);
})();
